// removed by extract-text-webpack-plugin
module.exports = {"row":"_10lV"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Billing/BillingBankAccountRow/BillingBankAccountRow.scss
// module id = 2LWg
// module chunks = 0